// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.field {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.field-label {
    font-size: 14px;
    font-weight: 600;
    color: #334155;
}

.field input,
.field textarea {
    width: 100%;
    padding: 14px 16px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    color: #0f172a;
    font: inherit;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.field input:hover,
.field textarea:hover {
    background: #ffffff;
    border-color: #cbd5e1;
}

.field input:focus,
.field textarea:focus {
    outline: none;
    background: #ffffff;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.field textarea {
    resize: vertical;
    min-height: 120px;
}

.field-error input,
.field-error textarea {
    border-color: #ef4444;
    background: #fffafb;
}

.field-error input:focus,
.field-error textarea:focus {
    border-color: #ef4444;
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.14);
}

.field-error-text {
    font-size: 13px;
    color: #dc2626;
    line-height: 1.4;
}

.submit-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.field input::placeholder,
.field textarea::placeholder {
    color: #94a3b8;
}

.hp-field {
    position: absolute;
    left: -9999px;
    opacity: 0;
    pointer-events: none;
}
.button {
    position: relative;
    overflow: hidden;
}

.button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    box-shadow: none;
}

.button-primary:disabled {
    background: linear-gradient(90deg, #cbd5e1, #94a3b8);
    color: #f1f5f9;
}

.button:disabled:hover,
.button-primary:disabled:hover {
    transform: none;
    box-shadow: none;
}
.button:disabled::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: linear-gradient(
            90deg,
            transparent,
            rgba(255,255,255,0.2),
            transparent
    );
    animation: shimmer 1.2s infinite;
}

@keyframes shimmer {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
}

`, "",{"version":3,"sources":["webpack://./src/ContactForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,8EAA8E;AAClF;;AAEA;;IAEI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oDAAoD;IACpD,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB;;;;;KAKC;IACD,gCAAgC;AACpC;;AAEA;IACI,KAAK,4BAA4B,EAAE;IACnC,OAAO,2BAA2B,EAAE;AACxC","sourcesContent":[".contact-form {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.field {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.field-label {\n    font-size: 14px;\n    font-weight: 600;\n    color: #334155;\n}\n\n.field input,\n.field textarea {\n    width: 100%;\n    padding: 14px 16px;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    background: #f8fafc;\n    color: #0f172a;\n    font: inherit;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n}\n\n.field input:hover,\n.field textarea:hover {\n    background: #ffffff;\n    border-color: #cbd5e1;\n}\n\n.field input:focus,\n.field textarea:focus {\n    outline: none;\n    background: #ffffff;\n    border-color: #2563eb;\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);\n}\n\n.field textarea {\n    resize: vertical;\n    min-height: 120px;\n}\n\n.field-error input,\n.field-error textarea {\n    border-color: #ef4444;\n    background: #fffafb;\n}\n\n.field-error input:focus,\n.field-error textarea:focus {\n    border-color: #ef4444;\n    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.14);\n}\n\n.field-error-text {\n    font-size: 13px;\n    color: #dc2626;\n    line-height: 1.4;\n}\n\n.submit-button:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.field input::placeholder,\n.field textarea::placeholder {\n    color: #94a3b8;\n}\n\n.hp-field {\n    position: absolute;\n    left: -9999px;\n    opacity: 0;\n    pointer-events: none;\n}\n.button {\n    position: relative;\n    overflow: hidden;\n}\n\n.button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n.button-primary:disabled {\n    background: linear-gradient(90deg, #cbd5e1, #94a3b8);\n    color: #f1f5f9;\n}\n\n.button:disabled:hover,\n.button-primary:disabled:hover {\n    transform: none;\n    box-shadow: none;\n}\n.button:disabled::after {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    border-radius: inherit;\n    background: linear-gradient(\n            90deg,\n            transparent,\n            rgba(255,255,255,0.2),\n            transparent\n    );\n    animation: shimmer 1.2s infinite;\n}\n\n@keyframes shimmer {\n    0% { transform: translateX(-100%); }\n    100% { transform: translateX(100%); }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
